import { type ReactNode } from 'react'
import { observer } from 'mobx-react-lite'
import { Alert, Divider, EmptyCell } from 'shared/ui'
import { ModalInfoBlock } from 'shared/ui/Modal/ui/ModalInfoBlock/ModalInfoBlock'
import { type IModalInfoRowProps } from 'shared/ui/Modal/ui/ModalInfoRow/ModalInfoRow'
import { type IResponseVoiceIntegrity } from 'entities/Compliance/api/types/voiceServicesTypes'
import { ModalHeader } from 'pages/settings/pages/compliance/ui/ModalHeader/ModalHeader'
import styles from './styles.module.scss'

type IBrandModalContentProps = {
  voiceIntegrity: IResponseVoiceIntegrity | null
  statusData: ReactNode
  errorMessage?: string | null
  updateModalAction: () => void
  learnMoreModalAction: () => void
}

export const VoiceIntegrityModalContent = observer(
  ({
    voiceIntegrity,
    statusData,
    errorMessage,
    updateModalAction,
    learnMoreModalAction,
  }: IBrandModalContentProps) => {
    const { average_business_day_call_volume, business_employee_count, use_case, notes } =
      voiceIntegrity || {}

    const lines: IModalInfoRowProps[] = [
      {
        label: 'Use case',
        value: use_case || '',
      },
      {
        label: 'Company size',
        value: business_employee_count,
      },
      {
        label: 'Average calls per day',
        value: average_business_day_call_volume,
      },
      {
        label: 'Notes',
        value: notes || <EmptyCell />,
      },
    ]

    return (
      <>
        <ModalHeader header={use_case || ''} statusData={statusData} />

        <Divider sx={{ marginBottom: '30px' }} />

        {errorMessage && (
          <Alert
            item={{
              type: 'error',
              desc: errorMessage,
            }}
            marginBottom={32}
            actions={[
              {
                type: 'primary',
                variant: 'button',
                text: 'Update',
                onClick: updateModalAction,
              },
              {
                type: 'secondary',
                variant: 'button',
                text: 'Learn more',
                onClick: learnMoreModalAction,
              },
            ]}
          />
        )}

        {!errorMessage && <div className={styles.divider} />}

        <ModalInfoBlock lines={lines} />
      </>
    )
  }
)
